define('Components/OrderStatWidget/js/models/OrderStatWidgetInstanceModel',['underscore','backbone','WidgetInstanceModel','app', 'formatPrice', 'moment'],function(_,Backbone,WidgetInstanceModel,app,formatPrice,moment){

    function getNeolaneParam(key){
        return parseInt(app.getCustomer().getNeolaneParam(key,0))
    }

    return WidgetInstanceModel.extend({
        name:'OrderStatWidgetModel',

        getAmount:function(){

        },
        formatAmount:function () {
            return  formatPrice(this.getAmount());
        },
        isExpire:function () {
            return false;
        },
        getPercent: function(val, scaleMin, scaleMax, scaleVal){
            var max = Math.max(parseInt(scaleVal), parseInt(scaleMax)),
                min = Math.min(parseInt(scaleVal), parseInt(scaleMin));
            return Math.sqrt(parseInt(val) - min) / Math.sqrt(max - min) * 90 + 5; // Marges de 5% sur les coté donc on calcule la valeur sur 90% et on ajoute 5% pour la marge de gauche
        },
        getOrderNbr:function()
        {
            return getNeolaneParam('countOrderMonth12',0);
        },
        getOrderValue:function()
        {
            return getNeolaneParam('sumAmountMonth12',0);
        },
        formatExpirationDate:function () {

        }
    })
});
